import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

type Result = ModelHookResult<{
	isSunriseActionPanelEnabled: boolean;
	isSunriseContentSummaryEnabled: boolean;
	isSunriseDescriptionEnabled: boolean;
	isSunriseDmSectionEnabled: boolean;
	isSunriseHeadingEnabled: boolean;
	isSunriseMediaHitsEnabled: boolean;
	isSunriseMediaMentionsEnabled: boolean;
	isSunriseMembershipAwarenessEnabled: boolean;
	isSunrisePetitionStarterEnabled: boolean;
	isSunrisePetitionUpdatesEnabled: boolean;
	isSunriseShareModuleExperimentEnabled: boolean;
	isSunrisePromotedPetitions: boolean;
	isSunriseReportAbuseEnabled: boolean;
	isSunriseRecentSigners: boolean;
	isSunriseSharePetitionEnabled: boolean;
	isSunriseSupporterVoicesEnabled: boolean;
	isSunriseSupportersEnabled: boolean;
	sunriseActionPanelExperimentVariation: string;
}>;

// eslint-disable-next-line complexity
export const useIsFullSunriseEnabled = (): Result => {
	const {
		data: {
			featureConfigs: { petitionPageFullSunrise },
		},
	} = usePetitionDetailsPageData();

	const {
		data: { fullSunrisePetitionPageShareComponentExperiment, fullSunriseActionPanelExperimentVariation },
	} = usePetitionDetailsPageUserData();

	/* We will use the FC to determine if full sunrise is enabled for a given module.
	 * In case a module is being experimented on, we will only fetch the experiment, no need for the FC since
	 * the experiment will use the FC under the hood.
	 */
	const {
		actionPanel,
		contentSummary,
		dmSection,
		mediaHits,
		membershipAwareness,
		mediaMentions,
		petitionDescription,
		petitionHeading,
		petitionStarter,
		petitionUpdates,
		promotedPetitions,
		recentSigners,
		sharePetition,
		supporterVoices,
		supporters,
		reportAbuse,
	} = petitionPageFullSunrise;

	return {
		data: {
			isSunriseActionPanelEnabled: !!actionPanel?.enabled,
			isSunriseContentSummaryEnabled: !!contentSummary?.enabled,
			isSunriseDescriptionEnabled: !!petitionDescription?.enabled,
			isSunriseDmSectionEnabled: !!dmSection?.enabled,
			isSunriseHeadingEnabled: !!petitionHeading?.enabled,
			isSunriseMediaHitsEnabled: !!mediaHits?.enabled,
			isSunriseMediaMentionsEnabled: !!mediaMentions?.enabled,
			isSunriseMembershipAwarenessEnabled: !!membershipAwareness?.enabled,
			isSunrisePetitionStarterEnabled: !!petitionStarter?.enabled,
			isSunrisePetitionUpdatesEnabled: !!petitionUpdates?.enabled,
			isSunrisePromotedPetitions: !!promotedPetitions?.enabled,
			isSunriseReportAbuseEnabled: !!reportAbuse?.enabled,
			isSunriseShareModuleExperimentEnabled: !!fullSunrisePetitionPageShareComponentExperiment,
			isSunriseRecentSigners: !!recentSigners?.enabled,
			isSunriseSharePetitionEnabled: !!sharePetition?.enabled,
			isSunriseSupporterVoicesEnabled: !!supporterVoices?.enabled,
			isSunriseSupportersEnabled: !!supporters?.enabled,
			sunriseActionPanelExperimentVariation: fullSunriseActionPanelExperimentVariation,
		},
	};
};
